import { HardDrive, Image as ImageIcon, Plus, Save, Shield } from 'lucide-react'

import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

export const VaultSettings = () => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <HardDrive className="size-4 text-muted-foreground" />
              Storage
            </CardTitle>
            <CardDescription>Manage storage limits and locations</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-1.5">
              <Label>Max upload size (MB)</Label>
              <Input type="number" defaultValue={50} />
            </div>
            <div className="space-y-1.5">
              <Label>Total storage limit (GB)</Label>
              <Input type="number" defaultValue={10} />
            </div>
            <div className="flex items-center justify-between border-t border-border-subtle pt-4">
              <Label>Compression on upload</Label>
              <Switch defaultChecked />
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Shield className="size-4 text-muted-foreground" />
              Security
            </CardTitle>
            <CardDescription>Access control and permissions</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between">
              <Label>Public access</Label>
              <Switch defaultChecked />
            </div>
            <div className="flex items-center justify-between">
              <Label>Require authentication</Label>
              <Switch defaultChecked />
            </div>
            <div className="space-y-1.5 border-t border-border-subtle pt-4">
              <Label>Allowed file types</Label>
              <div className="flex flex-wrap items-center gap-2">
                <Badge tone="soft">JPG</Badge>
                <Badge tone="soft">PNG</Badge>
                <Badge tone="soft">PDF</Badge>
                <Badge tone="soft">MP4</Badge>
                <Button variant="outline" size="sm">
                  <Plus />
                  Add
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <ImageIcon className="size-4 text-muted-foreground" />
              Image processing
            </CardTitle>
            <CardDescription>Automatic image handling</CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="flex items-center justify-between">
              <Label>Auto-generate WebP</Label>
              <Switch defaultChecked />
            </div>
            <div className="flex items-center justify-between">
              <Label>Strip metadata</Label>
              <Switch defaultChecked />
            </div>
            <div className="space-y-1.5 border-t border-border-subtle pt-4">
              <Label>Default quality</Label>
              <Input type="number" defaultValue={80} max={100} />
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="flex justify-end">
        <Button className="w-full sm:w-auto">
          <Save />
          Save
        </Button>
      </div>
    </div>
  )
}
